import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListGrammarTriageQueueV1Request } from './list-grammar-triage-queue-v1-request';
import type { IListGrammarTriageQueueV1Response } from './list-grammar-triage-queue-v1-response';
import { listGrammarTriageQueueV1ResponseSchema } from './list-grammar-triage-queue-v1-response';

export async function listGrammarTriageQueueV1Api(
  params: IListGrammarTriageQueueV1Request = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListGrammarTriageQueueV1Response>> {
  const search = new URLSearchParams();
  if (params.cursor !== undefined) {
    search.set('cursor', String(params.cursor));
  }
  if (params.limit !== undefined) {
    search.set('limit', String(params.limit));
  }
  const query = search.toString();
  return getRequest<IListGrammarTriageQueueV1Response>({
    path: `/sys/grammar/v1/triage${query ? `?${query}` : ''}`,
    schema: listGrammarTriageQueueV1ResponseSchema,
    options,
  });
}
